<template>
    <header class="header" v-if="setup != null" id="header">
        <div class="container">
            <div class="header-container">
                <div class="logo-bcn">
                    <router-link to="/" @click.native="startLoader">
                        <img :src="setup.logo_bcn" alt="BCN LOGO">
                    </router-link>
                </div>
                <div class="header-navigation">
                    <div class="inner-content">
                        <div class="home-link">
                            <router-link to="/">
                                <svgIcon name="home" class="icon-home"/>
                            </router-link>
                        </div>
                        <navMain class="header-nav"></navMain>
                        <div class="lang-selector">
                            <div class="current-lang" @click="langOpen = !langOpen" :class="{'open': langOpen}">
                                <div v-if="globalLang == 'kz/'">Каз <span></span></div>
                                <div v-if="globalLang == ''">Рус <span></span></div>
                                <div v-if="globalLang == 'en/'">Еng <span></span></div>
                            </div>
                            <div class="dropdown-lang" :class="{'open': langOpen}">
                                <ul>
                                    <li v-if="globalLang != 'kz/'"><a href="#" @click.prevent="setLocale('kz/')">Каз</a></li>
                                    <li v-if="globalLang != ''"><a href="#" @click.prevent="setLocale('')">Рус</a></li>
                                    <li v-if="globalLang != 'en/'"><a href="#" @click.prevent="setLocale('en/')">Еng</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>  
                <div class="mobile-menu" :class="{open: openSendwich}" @click="openMobileMenu(!openSendwich)">
                    <span></span>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    import {mapGetters} from 'vuex'
    import navMain from '@/components/nav-main/nav-main.vue'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'AppHeader',
        components: {
            navMain,
            svgIcon,
        },
        data () {
            return {
                langOpen: false,
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            openSendwich: 'loadOpenSendwich',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            setLocale(lang) {
                localStorage.setItem('languageBCN', lang);
                document.location.reload(true);
            },
            openMobileMenu(data) {
                this.$store.commit('Open_Sendwich', data);
                this.$store.commit('Open_form_Consult', false);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
                // if (data === true) {
                //     document.getElementById('secret-btns').classList.remove('fadeIn');
                // } else {
                //     if (window.scrollY >= window.innerHeight) {
                //         document.getElementById('secret-btns').classList.add('fadeIn');
                //     }
                // }
            },
            startLoader() {
                this.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/header/header.scss';
    @import '@/styles/components/header/header-respond.scss';
</style>